import { useEffect, useState } from 'react';

export const useSelection = (query: unknown) => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  useEffect(() => {
    // Reset the selection when the query changes, e.g. a filter was applied
    setSelectedIds(new Set());
  }, [query]);
  return {
    selectedIds,
    setSelectedIds,
  };
};
